// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueSession from 'vue-session'
import {
  store
} from './store/store'
import {
  Conf
} from './conf/defaults'
import 'babel-polyfill'
import vuetify from './plugins/vuetify';

/*
// Commento sentry, non avendolo mai usato

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";


Sentry.init({
  dsn: "https://18c0e60ecf274f629fdaf0ea43e0d99d@o472647.ingest.sentry.io/5512478",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
*/

//  https://jsfiddle.net/x0qufw78/

export const serverBus = new Vue()

/*Vue.use(Vuetify, {
  theme: {
    primary: '#00bfa5',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#ff1744',
    info: '#2979ff',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})*/

var options = {
  persist: true
}
Vue.use(VueSession, options)
/*Vue.use(Vuetify, {
  icons: {
    iconfont: 'md' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  }
})*/

Vue.config.productionTip = false
Vue.config.silent = true;
Vue.prototype.$windowTitle = Conf.windowTitle

/* eslint-disable no-new */
new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')